import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import { useState } from 'react';
import type * as React from 'react';
import { TopBar } from '@/components/Layout/TopBar.tsx';
import { LeftDrawer } from './LeftDrawer';
import { Outlet } from '@/components/Layout/Outlet.tsx';
import { topBarHeight } from './constants';
import Logo from '@/assets/logo/Satos-28.svg';

export const Layout = () => {
  const [openLeftDrawer, setOpenLeftDrawer] = useState<boolean>(false);
  const [anchorElUser, setAnchorElUser] = useState<null | HTMLElement>(null);

  const handleOpenRightDrawer = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseRightDrawer = () => {
    setAnchorElUser(null);
  };

  const handleToggleLeftDrawer = () => {
    setOpenLeftDrawer((prev) => !prev);
  };

  const handleCloseLeftDrawer = () => {
    setOpenLeftDrawer(false);
  };

  return (
    <Box
      sx={(theme) => ({
        display: 'flex',
        height: '100vh',
        overflow: 'hidden',
        backgroundColor: 'background.default',
        '--closed-drawer-width': `calc(${theme.spacing(7)} + 1px)`,
        [theme.breakpoints.up('md')]: {
          '--closed-drawer-width': `calc(${theme.spacing(8)} + 1px)`,
        },
        [theme.breakpoints.down('sm')]: {
          '--closed-drawer-width': '0px',
        },
      })}
    >
      <IconButton
        disableRipple
        color="inherit"
        aria-label="toggle drawer"
        onClick={handleToggleLeftDrawer}
        sx={(theme) => ({
          position: 'fixed',
          left: theme.spacing(1),
          top: 0,
          height: topBarHeight,
          zIndex: theme.zIndex.drawer + 2,
          display: { xs: 'none', sm: 'flex' },
          alignItems: 'center',
          pl: 0,
          '&:hover': { background: 'none' },
          '& svg': {
            width: '120px',
            height: 'auto',
          },
        })}
      >
        <Logo />
      </IconButton>
      <TopBar
        openLeftDrawer={openLeftDrawer}
        handleOpenLeftDrawer={handleToggleLeftDrawer}
        anchorElUser={anchorElUser}
        handleOpenRightDrawer={handleOpenRightDrawer}
        handleCloseRightDrawer={handleCloseRightDrawer}
      />
      <LeftDrawer open={openLeftDrawer} onClose={handleCloseLeftDrawer} />
      <Outlet />
    </Box>
  );
};
